import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, } from 'rxjs';
import { AlertMessage } from './alert-types';

@Injectable({
    providedIn: 'root'
})
export class AlertService {
    private alertMessage = new BehaviorSubject<AlertMessage>(undefined);

    alerts$: Observable<AlertMessage> = this.alertMessage.asObservable().pipe(filter(x => x != undefined && !x.dismissed));

    alert(alertMessage: AlertMessage) {
        if(!alertMessage.dismissed){
            alertMessage.dismissed = false;
        }
        this.alertMessage.next(alertMessage);
    }
}
